import styled from 'styled-components';
import {Label} from '../../atoms/Label/index';
import IconButton from '../../atoms/IconButton';
import {RemoveIcon} from '../../atoms/Icons';
import {OnPrimaryVariant,Grey600,LightPrimaryColor,DividerColor,SurfaceColor} from '../../Colors';

export default {
	Wrapper : styled.div`
		cursor : move;
        padding : 0.5rem;
        border : 1px solid ${DividerColor};
		border-radius : 3px;
		color : ${OnPrimaryVariant};
		background-color : ${ ({isAnswer}) => isAnswer ?  LightPrimaryColor : SurfaceColor};
		font-weight : ${ ({isAnswer}) => isAnswer ?  'bold' : 'normal'};
		display : flex;
		align-items : center;
		&>:last-child{
			margin-left : auto;
		}
	`,
	Label : styled(Label)`
		margin : 0;
		padding-right : 1rem;
	`,
	Text : styled.div`
		margin-right : 1rem;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		min-width: 0;
	`,
	IconButton : styled(IconButton)`
		&:hover{
			color : ${Grey600};
		}
	`,
	RemoveIcon,
};